import _ from "lodash";
import Vue from "vue";
import bugsnag from "@bugsnag/js";
import bugsnagVue from "@bugsnag/plugin-vue";

import store from "@/store/index";
import { getEnvironment, getWebVersion } from "@/utils/env";

const bugsnagClient = bugsnag({
	apiKey: "f4fda63bbf908b8aa9340052eb50174b",
	releaseStage: getEnvironment(),
	appVersion: getWebVersion(),

	beforeSend: report => {
		let community = null;
		try {
			community = store.getters["session/community"];
			community = _.pick(community, ["identifier", "name"]);
		} catch (e) {
			// Don't throw no matter what!
		}

		let system = null;
		try {
			system = store.getters["session/system"];
			system = _.pick(system, ["id", "name"]);
		} catch (e) {
			// Don't throw no matter what!
		}

		// Attach user selected community/system information to report
		report.updateMetaData("user", {
			context: {
				community,
				system,
			},
		});
	},
});

bugsnagClient.use(bugsnagVue, Vue);

Vue.prototype.$bugsnagClient = bugsnagClient;
